export default __webpack_public_path__ + "static/media/REDEMPTION_REMIX.ba4cf971.svg";